import { useGetSoremonStatusQuery } from "../../app/services/soremon";
import { getAuthTokenFromCookies } from "../../common/utils";
import { isDemoMode } from "../../utils/demoMode";

/**
 * soremon を表示してよいか（BE が利用可と返したか）。
 * 未ログイン・デモモードでは問い合わせ自体をしない。結果は RTK Query の
 * キャッシュを共有するので、ヘッダーとパネルの両方から呼んでよい。
 */
export const useSoremonAvailable = (): boolean => {
  const skip = !getAuthTokenFromCookies() || isDemoMode();
  const { data } = useGetSoremonStatusQuery(undefined, { skip });
  return !skip && data?.available === true;
};
